"use client";

import DropdownIcon from "@/Components/Common/Icons/DropdownIcon";
import React, { useState } from "react";

const FrequentlyAskedQuestions = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <div className="w-full mx-auto mt-4 pb-2">
        <div
          onClick={toggleAccordion}
          className="w-full text-left border border-[#E1E1E1] p-4 rounded-lg  flex flex-col  cursor-pointer focus:outline-none"
        >
          <div className="flex justify-between items-center w-full">
            <span className="text-[14px] font-medium font-poppins text-black">
              How much does Humira cost without insurance?
            </span>
            <DropdownIcon />

          </div>
          {isOpen && (
            <div className="mt-2  rounded-lg ">
              <div className="text-[16px] font-normal text-[#4B4B4B] font-poppins leading-tight">


                The cost of Humira without insurance can vary, but it typically
                ranges from $5,000 to $6,000 per month. Prices may vary based on
                location and pharmacy.
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FrequentlyAskedQuestions;
